<template>
  <div class="header__Modal">
    <h3 v-text="$t('header.contact')" />
    <div class="header__ModalSection">
      <div v-if="contact?.phone_number">
        <h4 v-text="$t('header.phone')" />
        <a :href="'tel:' + contact.phone_number" v-text="contact.phone_number" class="header__ModalPhoneNumber" />
        <p v-if="contact.working_hours" v-text="contact.working_hours" class="header__ModalHours" />
      </div>
      <div v-if="contact?.email">
        <h4 v-text="$t('header.email')" />
        <a :href="'mailto:' + contact.email" v-text="contact.email" />
      </div>

      <div>
        <h4 v-text="$t('header.help')" />
        <nuxt-link :to="link('FAQ')">{{ $t('header.findAnswers') }}</nuxt-link>
      </div>
    </div>
    <NuxtLink :to="link('AvailabilityContact')" class="button--Primary fullWidth">{{ $t('header.offer') }}</NuxtLink>
  </div>
</template>

<script setup>
  const { initialData, link } = useSetup();
  const contact = computed(() => initialData.value.contact);
</script>